module.exports = __webpack_public_path__ + "static/media/full-logo-tagline.429fd3d1.png";